import { render, staticRenderFns } from "./ordinary.vue?vue&type=template&id=70eceadb"
import script from "./ordinary.vue?vue&type=script&lang=js"
export * from "./ordinary.vue?vue&type=script&lang=js"
import style0 from "./ordinary.vue?vue&type=style&index=0&id=70eceadb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports